import React from 'react';
import { motion } from 'framer-motion';
import { useForm, ValidationError } from '@formspree/react';
import SectionReveal from './SectionReveal';

const ContactSectionV2 = () => {
	const [state, handleSubmit] = useForm("manbqwnb");

	if (state.succeeded) {
		return (
			<section id="contact" className="py-24 bg-ink/90">
				<div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
					<motion.div
						initial={{ opacity: 0, scale: 0.9 }}
						animate={{ opacity: 1, scale: 1 }}
						transition={{ duration: 0.5, ease: 'easeOut' }}
						className="bg-panel border border-legendary/60 rounded-lg p-10 shadow-[0_0_40px_rgba(245,166,35,0.3)]"
					>
						<div className="font-mono text-xs uppercase tracking-widest text-legendary mb-3">
							🏆 Quest Complete
						</div>
						<p className="font-display text-2xl text-gold mb-4">Message Sent!</p>
						<p className="text-gray-400 mb-6">
							Thank you for reaching out. I'll get back to you as soon as possible.
						</p>
						<button
							onClick={() => window.location.reload()}
							className="px-6 py-3 bg-gold rounded-md text-ink font-semibold hover:shadow-[0_0_20px_rgba(201,164,74,0.6)] transition-shadow"
						>
							Send Another Message
						</button>
					</motion.div>
				</div>
			</section>
		);
	}

	return (
		<section id="contact" className="py-24 bg-ink/90">
			<SectionReveal className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="text-center mb-16">
					<div className="font-mono text-xs uppercase tracking-[0.3em] text-rpgblue mb-2">
						Guild Hall
					</div>
					<h2 className="font-display text-3xl font-semibold mb-4 text-gold">Get In Touch</h2>
				</div>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-12">
					<div className="bg-panel border border-gold/30 rounded-lg p-8">
						<h3 className="font-display text-lg font-semibold mb-6 text-gold">Contact Information</h3>
						<div className="space-y-6 text-gray-400 font-mono text-sm">
							<div>Email: <a href="mailto:oluwatobitogun@gmail.com" className="text-rpgblue">oluwatobitogun@gmail.com</a></div>
							<div>Location: Stavanger, Norway</div>
							<div>LinkedIn: <a href="https://www.linkedin.com/in/oluwatobi-togun/" className="text-rpgblue">linkedin.com/in/oluwatobi-togun</a></div>
							<div>GitHub: <a href="https://github.com/TOGUNOLUWATOBI" className="text-rpgblue">github.com/TOGUNOLUWATOBI</a></div>
						</div>
					</div>
					<div className="bg-panel border border-gold/30 rounded-lg p-8">
						<h3 className="font-display text-lg font-semibold mb-6 text-gold">Send Me a Message</h3>
						<form className="space-y-6" onSubmit={handleSubmit}>
							<div>
								<label htmlFor="name" className="block text-sm font-medium text-gray-300 mb-1">Your Name</label>
								<input type="text" id="name" name="name" className="w-full px-4 py-2 bg-ink border border-gold/30 rounded-md focus:outline-none focus:ring-2 focus:ring-gold text-gray-100" required />
								<ValidationError prefix="Name" field="name" errors={state.errors} className="text-red-400 text-xs mt-1" />
							</div>
							<div>
								<label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-1">Your Email</label>
								<input type="email" id="email" name="email" className="w-full px-4 py-2 bg-ink border border-gold/30 rounded-md focus:outline-none focus:ring-2 focus:ring-gold text-gray-100" required />
								<ValidationError prefix="Email" field="email" errors={state.errors} className="text-red-400 text-xs mt-1" />
							</div>
							<div>
								<label htmlFor="subject" className="block text-sm font-medium text-gray-300 mb-1">Subject</label>
								<input type="text" id="subject" name="subject" className="w-full px-4 py-2 bg-ink border border-gold/30 rounded-md focus:outline-none focus:ring-2 focus:ring-gold text-gray-100" />
							</div>
							<div>
								<label htmlFor="message" className="block text-sm font-medium text-gray-300 mb-1">Message</label>
								<textarea id="message" name="message" rows="4" className="w-full px-4 py-2 bg-ink border border-gold/30 rounded-md focus:outline-none focus:ring-2 focus:ring-gold text-gray-100" required></textarea>
								<ValidationError prefix="Message" field="message" errors={state.errors} className="text-red-400 text-xs mt-1" />
							</div>
							<motion.button
								whileHover={{ scale: 1.02, rotate: -0.5 }}
								whileTap={{ scale: 0.97 }}
								type="submit"
								className="w-full px-6 py-3 bg-gold border-2 border-black rounded-md text-ink font-semibold hover:bg-blorange hover:shadow-[0_0_20px_rgba(255,106,26,0.6)] transition-colors disabled:opacity-60"
								disabled={state.submitting}
							>
								{state.submitting ? 'Sending...' : '⚔ Send Message'}
							</motion.button>
							<ValidationError errors={state.errors} className="text-red-400 text-sm mt-2" />
						</form>
					</div>
				</div>
			</SectionReveal>
		</section>
	);
};

export default ContactSectionV2;
